module.exports = __webpack_public_path__ + "img/hockey-stick-puck.9bd34cd0.svg";